import type { CSSProperties } from 'react';
import { iconBackground, type DesktopItem } from './items';

/** mac-style squircle icon: coloured gradient + two-letter mark for apps, glass tile + line icon for OS pages. */
export function AppIcon({ item, size = 64, className }: { item: DesktopItem; size?: number; className?: string }) {
  const style: CSSProperties & { '--icon-bg'?: string } = { width: size, height: size, fontSize: Math.round(size * 0.34) };
  if (item.kind === 'app') style['--icon-bg'] = iconBackground(item.id);
  const Icon = item.icon;
  return (
    <span className={`app-icon${className ? ` ${className}` : ''}`} data-kind={item.kind} style={style} aria-hidden>
      {item.kind === 'app' ? item.mark : Icon ? <Icon size={Math.round(size * 0.46)} strokeWidth={1.6} /> : null}
    </span>
  );
}

/** Four-pane Windows-style logo used for the Start button. */
export function WindowsLogo() {
  return <span className="win-logo" aria-hidden><span /><span /><span /><span /></span>;
}
